import {
  Box,
  Button,
  Modal
} from '@platform/ui-library';
import {
  FC,
  Fragment,
  useState
} from 'react';
import { SwitchControl } from '@app/form_components';
import { useCustomNavigate, useServices } from '@app/hooks';
import { Option, UserFeatureFlag } from '@app/types';

const featureFlags: Option<UserFeatureFlag>[] = [
  {
    label: 'CORE-33213 - Banner Message Node',
    value: UserFeatureFlag.banner
  },
  {
    label: 'CORE-30729 - D1 Import',
    value: UserFeatureFlag.d1import
  },
  {
    label: 'DEVDES2-894 About Tab in Settings',
    value: UserFeatureFlag.inventory
  },
  {
    label: 'CORE-31036 - Rich Text Node',
    value: UserFeatureFlag.richText
  },
  {
    label: 'DEVDES2-1577 Wizard Config',
    value: UserFeatureFlag.wizardConfig
  }
];

export const HomeFeaturesPage: FC = () => {
  const navigate = useCustomNavigate();
  const { featureFlagService } = useServices();
  const getEnabledFlags = (): Set<UserFeatureFlag> => {
    return new Set(featureFlags.map(({ value }) => {
      return value;
    }).filter((flag) => {
      return featureFlagService.isFeatureOn(flag);
    }));
  };
  const [enabledFlags, setEnabledFlags] = useState(getEnabledFlags());

  return (
    <Modal className="ui-box-small" isOpen>
      <Box theme='noPadding'>
        <div className="box header">
          <h2>Feature Flags</h2>
        </div>
        <div className="box content">
          {featureFlags.map(({ label, value: flag }) => {
            const enabled = enabledFlags.has(flag);
            return (
              <Fragment key={flag}>
                <label className="flex-gap">
                  <SwitchControl
                    name={flag}
                    onChange={(newEnabled) => {
                      featureFlagService.setFeature(flag, newEnabled);
                      setEnabledFlags(getEnabledFlags());
                    }}
                    value={enabled}
                  />
                  {label}
                </label>
              </Fragment>
            );
          })}
        </div>
        <div className="box footer">
          <Button
            onClick={() => {
              navigate('..');
            }}
            theme="outline"
            type="button"
          >
            Close
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
